import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, inject } from "@angular/core";

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
   selector: "[highlightSearch]"
})
export class HighlightSearchDirective implements OnChanges, AfterViewInit {
   private elementRef = inject(ElementRef);
   private renderer = inject(Renderer2);

   private element: HTMLElement;
   private label?: string;

   @Input() public highlightSearch: boolean = true;
   @Input() public searchTerm?: string;

   constructor() {
      this.element = this.elementRef.nativeElement;
   }

   public ngOnChanges(): void {
      if (this.canHighlight) {
         this.highlightLabel();
      }
   }

   public ngAfterViewInit(): void {
      this.label = this.element.innerHTML;

      if (this.canHighlight && this.label) {
         this.highlightLabel();
      }
   }

   private get canHighlight(): boolean {
      return (
         this.isDefined(this.searchTerm) &&
         this.isDefined(this.label) &&
         this.highlightSearch
      );
   }

   private isDefined(value: any): boolean {
      return value !== undefined && value !== null;
   }

   private escapeRegExText(text: string): string {
      return text?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
   }

   private setInnerHtml(text: any): void {
      this.renderer.setProperty(
         this.elementRef.nativeElement,
         "innerHTML",
         text
      );
   }

   private highlightLabel(): void {
      const label = this.label;

      if (!this.searchTerm) {
         this.setInnerHtml(label);
         return;
      }

      const alternationString = this.escapeRegExText(this.searchTerm)?.replace(
         " ",
         "|"
      );
      const termRegex = new RegExp(alternationString, "gi");

      this.setInnerHtml(label!.replace(termRegex, "<u><b>$&</b></u>"));
   }
}
